import React from 'react';
import AUX from '../../../hoc/Aux_';
import { MDBDataTable } from 'mdbreact';
import { Button } from 'reactstrap';

const UsList = [
  {
    id: 1,
    userName: 'Google Docs    1h 11m',
    role: `Slack       1h 42m`,
  },
  {
    id: 2,
    userName: '',
    role: 'Chrome       1h 42m',
  },
  {
    id: 3,
    userName: '',
    role: 'Chrome       1h 42m',
  },
  {
    id: 4,
    userName: '',
    role: 'VS Code       1h 42m',
  },
  {
    id: 5,
    userName: '',
    role: 'Vs Code       1h 42m',
  },
];

const Productivity = () => {
  const data = {
    columns: [
      {
        label: '',
        field: 'userName',
      },
      {
        label: '',
        field: 'firstName',
      },
      {
        label: '',
        field: 'mobileNumber',
      },
    ],
    rows: UsList.map((Item) => {
      return {
        userName: <div className="text-center">{Item?.userName}</div>,
        firstName: <>{Item?.role}</>,
        mobileNumber: 'No Dta',
      };
    }),
  };
  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <div className="card m-b-10">
                    <div className="d-flex justify-content-between align-items-center card-body">
                      <div className="col-md-8 d-flex justify-content-start">
                        <select className="form-control btn-sm col-3">
                          <option value="true">Lilit Nurijanyan</option>
                          <option value="false">Avnee K</option>
                        </select>
                        <p className="text-muted ml-4 mt-1 d-flex justify-content-start align-items-center">
                          <i className="mdi mdi-calendar-text font-20 mr-2 text-muted"></i>{' '}
                          2011-11-28 -&gt; 2022-12-04{' '}
                        </p>
                      </div>
                      <Button className="btn bg-dark pl-4 pr-4" size="sm">
                        Apply
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card m-b-10">
                    <div className="d-flex justify-content-start align-items-center card-body ">
                      <span className="d-flex justify-content-start align-items-center user_border">
                        <i className="mdi mdi-account-multiple font-40 text-info text-center"></i>
                      </span>
                      <div className="col-md-8 ml-4 mt-2">
                        <span className="font-16 ">Lilit Nurijanyan</span>
                        <p className=" text-muted font-14">
                          Member since : Feb 09, 2016
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card m-b-10">
                    <div className="d-flex justify-content-around align-items-center card-body ">
                      <div className="col-md-6 d-flex flex-column">
                        <span>Tracked : 7h 58m</span>
                        <span>Idle : 0m</span>
                        <span>Manual : 0m</span>
                      </div>
                      <div className="col-md-8 ml-4">
                        <span className="font-16 ">AVG mouse / minute : 3</span>
                        <p className=" text-muted font-15">
                          AVG keyboard / minute : 6
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card m-b-10">
                <div className="card-body">
                  <div className="d-flex justify-content-between ">
                    <h6>Apps & Web Usage</h6>
                    <span className="text-muted">Score : 15 / 100</span>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-3 text-center bg-success text-white">
                      15 %
                    </div>
                    <div className="col-9 text-center bg-primary text-white">
                      85 %
                    </div>
                  </div>
                  <div className="d-flex justify-content-around align-items-center mt-1">
                    <div>
                      <b className="font-14">Productive</b>
                      <p className="font-14 text-success">Team AVG 13%</p>
                    </div>
                    <div>
                      <b className="font-14">Neutral</b>
                      <p className="font-14 text-primary">Team AVG 87%</p>
                    </div>
                    <div>
                      <b className="font-14">Non-Productive</b>
                      <p className="font-14 text-danger">Team AVG 0%</p>
                    </div>
                  </div>
                  <hr />
                  <MDBDataTable
                    bordered
                    hover
                    data={data}
                    paging={false}
                    searching={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default Productivity;
